export const durations = {
  '75': 'duration-75',
  '100': 'duration-100',
  '150': 'duration-150',
  '200': 'duration-200',
  '300': 'duration-300',
  '500': 'duration-500',
  '700': 'duration-700',
  '1000': 'duration-1000',
} as const;

export const propsDefaults = {
  duration: '500' as keyof typeof durations,
};
